<template>
    <b-dropdown
      split
      :split-variant="color"
      :variant="color + ' active'"
      size="sm"
      right
      target="_blank"
      @click="() => handleClientSideDownload('pdf')"
    >
      <template slot="button-content">
        <font-awesome-icon icon="cloud-download-alt"/>
        <span>{{t('Export')}}</span>
      </template>
      <b-dropdown-item @click="() => handleClientSideDownload('pdf')">{{t('Download pdf')}}</b-dropdown-item>
      <b-dropdown-item @click="() => handleClientSideDownload('rtf')">{{t('Download rtf')}}</b-dropdown-item>
<!--      <b-dropdown-item @click="() => handleClientSideDownload('html')">{{t('Download')}} html</b-dropdown-item>-->
      <a :href="exportFileData" :download="exportFileName" class="d-none" :id="`export-file-link-${application.fileHash}`"></a>
    </b-dropdown>
</template>
<script>

  export default {
    props: {
      color: {
        type: String,
        required: false,
        default: 'success',
      },
      application: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        exportFileData: null,
        exportFileName: null,
      }
    },
    methods: {
      handleClientSideDownload(fileType) {
        this.$store.dispatch('applications/export', {
            hash: this.application.fileHash,
            fileType,
            patient: this.application.patient,
          })
          .then(response => {
            this.exportFileData = response.file
            this.exportFileName = response.name
            // this.exportFileName = `download.${fileType}`


            this.$nextTick(() => {
                console.log('click here: ');
                console.log(`#export-file-link-${this.application.fileHash}`);
                console.log('found link: ');
                console.log(document.querySelector(`#export-file-link-${this.application.fileHash}`));
                document.querySelector(`#export-file-link-${this.application.fileHash}`).click();
            })
          })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/private/applications/client-side-download-button.vue